module.exports = "<div class=\"size-tabs-wrapper\">\r\n\t{{each tables}}\r\n\t<div class=\"size-tab{{if $index == 0}} active{{/if}}\" rel=\"${rel}\">\r\n\t\t${title}\r\n\t</div>\r\n\t{{/each}}\r\n</div>\r\n<div class=\"tabs-content\">\r\n\t{{each tables}}\r\n\t<div class=\"img-wrapper\" rel=\"${rel}\"{{if $index == 0}} style=\"display: block\"{{/if}}>\r\n\t\t<img src=\"${src}\">\r\n\t</div>\r\n\t{{/each}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./modules/shops/page/templates/size-table.html
// module id = Y7m/
// module chunks = 10